import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { BaseContentFragmentDoc } from '../../../../../../content/graphql/fragments/generated/BaseContent';
import { ScheduleFragmentDoc } from '../../../../../../1on1s/graphql/fragment/generated/Schedule';
import { ShareConfigFragmentDoc } from '../../../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/shareconfig';
import { SharedByWorkspaceFragmentDoc } from '../../../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type Contents_ArticleContentType_Fragment = { status: Types.ResourceStatusEnum, createdAt: string, updatedAt: string, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_BaseResourceSchema_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type Contents_CheckinType_Fragment = { createdAt: string, updatedAt: string, status: Types.ResourceStatusEnum, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_CourseContentType_Fragment = { status: Types.ResourceStatusEnum, createdAt: string, updatedAt: string, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, aiCourseCreatorAutomationJob?: { status: Types.JobEntityStatusEnum, jobScheduleId: string, meta?: { aiCourseCreatorMetadataType?: { completedStep: number, maxSteps?: number | null, contentId: string } | null } | null } | null, cover?: { url?: string | null } | null };

export type Contents_ExerciseType_Fragment = { status: Types.ResourceStatusEnum, createdAt: string, updatedAt: string, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_ExternalContentType_Fragment = { createdAt: string, updatedAt: string, status: Types.ResourceStatusEnum, externalContentType?: Types.ExternalContentTypeEnum | null, marketplaceContentId?: string | null, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, provider?: { id: string, name: string, url: string, logo: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } } | null, cover?: { url?: string | null } | null };

export type Contents_ExternalEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type Contents_HomeworkType_Fragment = { createdAt: string, updatedAt: string, status: Types.ResourceStatusEnum, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_KnowledgeAssetContentType_Fragment = { knowledgeAssetSubTypeVariant?: Types.KnowledgeAssetSubTypeVariantEnum | null, industries?: Array<Types.KnowledgeAssetIndustryEnum> | null, description?: string | null, status: Types.ResourceStatusEnum, approvalStatus?: Types.ContentApprovalStatusEnum | null, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null };

export type Contents_LiveEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type Contents_MicroLearningContentType_Fragment = { status: Types.ResourceStatusEnum, createdAt: string, updatedAt: string, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_OfflineEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type Contents_PathContentType_Fragment = { status: Types.ResourceStatusEnum, createdAt: string, updatedAt: string, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_QuizContentType_Fragment = { status: Types.ResourceStatusEnum, createdAt: string, updatedAt: string, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_RecurringExternalEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, recurrenceSchedule?: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null } | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type Contents_RecurringLiveEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, recurrenceSchedule?: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null } | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type Contents_RecurringOfflineEventContentType_Fragment = { id: string, name: string, duration: number, type: Types.ResourceTypeEnum, cover?: { url?: string | null } | null, event?: { id: string, status: Types.EventStatusEnum, recurringCategory?: Types.RecurringTypeEnum | null, recurrenceSchedule?: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null } | null, prework?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, postwork?: { contents: Array<{ contentId: string, isOptional: boolean }> } | null, completionSettings?: { considerRecordingProgress?: boolean | null } | null } | {} | null };

export type Contents_RoleplayContentType_Fragment = { status: Types.ResourceStatusEnum, createdAt: string, updatedAt: string, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, conversationTimeLimit?: number | null, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_ScormContentType_Fragment = { name: string, id: string, createdAt: string, updatedAt: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, duplicatable: boolean, shareable: boolean, duration: number, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_SurveyContentType_Fragment = { createdAt: string, updatedAt: string, status: Types.ResourceStatusEnum, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, cover?: { url?: string | null } | null };

export type Contents_TaskContentType_Fragment = { status: Types.ResourceStatusEnum, createdAt: string, updatedAt: string, duplicatable: boolean, shareable: boolean, id: string, name: string, duration: number, type: Types.ResourceTypeEnum, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, createdBy?: { name?: string | null, id: string, emailId?: string | null } | null, cover?: { url?: string | null } | null };

export type ContentsFragment = Contents_ArticleContentType_Fragment | Contents_BaseResourceSchema_Fragment | Contents_CheckinType_Fragment | Contents_CourseContentType_Fragment | Contents_ExerciseType_Fragment | Contents_ExternalContentType_Fragment | Contents_ExternalEventContentType_Fragment | Contents_HomeworkType_Fragment | Contents_KnowledgeAssetContentType_Fragment | Contents_LiveEventContentType_Fragment | Contents_MicroLearningContentType_Fragment | Contents_OfflineEventContentType_Fragment | Contents_PathContentType_Fragment | Contents_QuizContentType_Fragment | Contents_RecurringExternalEventContentType_Fragment | Contents_RecurringLiveEventContentType_Fragment | Contents_RecurringOfflineEventContentType_Fragment | Contents_RoleplayContentType_Fragment | Contents_ScormContentType_Fragment | Contents_SurveyContentType_Fragment | Contents_TaskContentType_Fragment;


export type ContentsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ContentsFragmentDoc = /*#__PURE__*/ gql`
    fragment Contents on ContentEntity {
  ...BaseContent
  ... on CheckinType {
    createdBy {
      name
      id
      emailId
    }
    createdAt
    updatedAt
    status
    duplicatable
    shareable
  }
  ... on SurveyContentType {
    createdBy {
      name
      id
      emailId
    }
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    createdAt
    updatedAt
    status
    duplicatable
    shareable
  }
  ... on HomeworkType {
    createdBy {
      name
      id
      emailId
    }
    createdAt
    updatedAt
    status
    duplicatable
    shareable
  }
  ... on CourseContentType {
    createdBy {
      name
      id
      emailId
    }
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    aiCourseCreatorAutomationJob {
      status
      jobScheduleId
      meta {
        aiCourseCreatorMetadataType {
          completedStep
          maxSteps
          contentId
        }
      }
    }
    status
    createdAt
    updatedAt
    duplicatable
    shareable
  }
  ... on ExerciseType {
    createdBy {
      name
      id
      emailId
    }
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    status
    createdAt
    updatedAt
    duplicatable
    shareable
  }
  ... on TaskContentType {
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    status
    createdBy {
      name
      id
      emailId
    }
    createdAt
    updatedAt
    duplicatable
    shareable
  }
  ... on PathContentType {
    createdBy {
      name
      id
      emailId
    }
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    status
    createdAt
    updatedAt
    duplicatable
    shareable
  }
  ... on QuizContentType {
    createdBy {
      name
      id
      emailId
    }
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    status
    createdAt
    updatedAt
    duplicatable
    shareable
  }
  ... on ExternalContentType {
    createdBy {
      name
      id
      emailId
    }
    createdAt
    updatedAt
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    status
    externalContentType
    marketplaceContentId
    provider {
      id
      name
      logo {
        ...EntityMedia
      }
      url
    }
    duplicatable
    shareable
  }
  ... on ArticleContentType {
    createdBy {
      name
      id
      emailId
    }
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    status
    createdAt
    updatedAt
    duplicatable
    shareable
  }
  ... on ScormContentType {
    name
    id
    createdBy {
      name
      id
      emailId
    }
    createdAt
    updatedAt
    type
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    status
    cover {
      url
    }
    duplicatable
    shareable
  }
  ... on KnowledgeAssetContentType {
    knowledgeAssetSubTypeVariant
    industries
    description
    status
    approvalStatus
  }
  ... on MicroLearningContentType {
    createdBy {
      name
      id
      emailId
    }
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    status
    createdAt
    updatedAt
    duplicatable
    shareable
  }
  ... on RoleplayContentType {
    createdBy {
      name
      id
      emailId
    }
    shareConfigs {
      ...ShareConfig
    }
    sharedByWorkspace {
      ...SharedByWorkspace
    }
    status
    createdAt
    updatedAt
    duplicatable
    shareable
  }
}
    `;